import React, { useRef } from "react";
import "./login.css";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useMutation, gql } from "@apollo/client";
import { Navigate, useNavigate  } from "react-router-dom";
import { datastore } from "../../datastore";
import { AffiliatePartner } from "../../providers/affiliatePartner";
import { jwtDecode } from "jwt-decode";

interface IProps {}

const LOGIN = gql`
  mutation partnerLogin($email: String!, $password: String!) {
    partnerLogin(email: $email, password: $password){
      id
      token
      userType
    }
  }
`;


const Login: React.FC<IProps> = () => {
 // const [showError, setShowError] = useState(false);
  const loginTextBox = useRef<HTMLInputElement | null>(null);
  const passwordTextBox = useRef<HTMLInputElement | null>(null);
  const [Login, { data: dataLogin, error: errorLogin}] = useMutation(LOGIN);
  const navigate = useNavigate();

  const handleForgotPasswordClicked = () => {
    navigate("/forgotpassword");
  };

  const handleLoginClicked = () => {
    Login({
      errorPolicy: "all",
      variables: {
        email: loginTextBox.current?.value,
        password: passwordTextBox.current?.value,
      },
    });
  };

  let showError = false;
  if (dataLogin) {
    showError = true;
  }

  //Is user allready logged in?
  const token = localStorage.getItem("id_token");
  if (token && token !== "") {
    var decodedToken = jwtDecode(token);

    var dateNow = new Date();
    if (decodedToken.exp) {
      if (decodedToken.exp * 1000 < dateNow.getTime()) {
        console.log("Token expired.");
        localStorage.removeItem("id_token");
      } else {
        console.log("Valid token");
        return (<AffiliatePartner><Navigate to="/leads" replace /></AffiliatePartner>);
      }
    }
  }

  if (dataLogin && dataLogin.partnerLogin && dataLogin.partnerLogin.token) {
    localStorage.setItem("id_token",  dataLogin.partnerLogin.token);
    localStorage.setItem("affiliatePartnerId",  dataLogin.partnerLogin.id);
    localStorage.setItem("userType", dataLogin.partnerLogin.userType);
    datastore.data.affiliatePartnerId =  dataLogin.partnerLogin.id;
    datastore.data.token = dataLogin.partnerLogin.token;
    datastore.data.userType = dataLogin.partnerLogin.userType;

    return (<AffiliatePartner><Navigate to="/leads" replace /></AffiliatePartner>);
  } else {
    return (
      <div className="login">
        <div className="logo">Settle</div>
        <div className="loginBackground"></div>
        <div className="loginContainer">
          <div className="loginBoxContainer">
            <div className="textContainer">
              <h1>Log ind</h1>
              {showError && <p className="warning">Din e-mailadresse eller adgangskode er forkert - prøv igen.</p>}
              <TextField fullWidth id="username" label="E-mailadresse" variant="standard" defaultValue={""} inputRef={loginTextBox} />
              <br />
              <br />
              <TextField fullWidth id="password" label="Adgangskode" variant="standard" type="password" defaultValue={""} inputRef={passwordTextBox} />
              <br />
            </div>
            <div className="buttonContainer">
              <p
                onClick={() => {
                  handleForgotPasswordClicked();
                }}
                style={{ cursor: "pointer" }}
              >
                <u>Glemt adgangskode</u>
              </p>
              <Button
                onClick={() => {
                  handleLoginClicked();
                }}
                className="loginButton"
                variant="contained"
              >
                Login
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
};
export default Login;
